import React from 'react';
import { Box, lighten, SxProps, useTheme } from '@mui/material';

export type DossierFormaliteProcessListHeaderCellsProps = {
    isHovered?: boolean;
    showStatus: boolean;
};
const DossierFormaliteProcessListHeaderCells: React.FunctionComponent<DossierFormaliteProcessListHeaderCellsProps> =
    function (props) {
        const { isHovered, showStatus } = props;
        const { palette } = useTheme();

        const tableHeadings = [
            '',
            'N°',
            'Démarches',
            'Informations',
            'Valideur',
            showStatus ? 'Statut' : '',
            '',
        ];
        const cellsSx: SxProps[] = [
            { width: isHovered ? '5%' : '0px' },
            { width: '5%' },
            { width: '40%' },
            { width: isHovered ? '25%' : '20%' },
            { width: showStatus ? '12.5%' : '30%' },
            { width: showStatus ? '17.5%' : '0%' },
            { width: '5%' },
        ];

        return (
            <Box sx={{ display: 'flex' }}>
                {tableHeadings.map((header, headerIndex) => {
                    let sx: SxProps = {
                        border: 'none',
                    };

                    if (cellsSx) {
                        const cellPropsSx =
                            cellsSx && cellsSx[headerIndex]
                                ? (cellsSx[headerIndex] as SxProps)
                                : undefined;
                        sx = { ...sx, ...cellPropsSx };
                    }

                    return (
                        <Box
                            sx={{
                                border: 'none',
                                padding: '2px 8px',
                                lineHeight: '1.6',
                                fontWeight: '500',
                                fontSize: '13px',
                                verticalAlign: 'middle',
                                color: lighten(palette.secondary.main, 0.5),
                                minWidth: '20px',
                                display: 'block',
                                ...sx,
                            }}
                            // eslint-disable-next-line react/no-array-index-key
                            key={`'header'-${headerIndex}`}
                        >
                            {header}
                        </Box>
                    );
                })}
            </Box>
        );
    };

export default DossierFormaliteProcessListHeaderCells;
